const tray = require('../components/tray');
var gtm = require('googletagmanager/tagManager');
const snackbar = require('../components/snackbar');

let setPrimaryUrl;
let primaryIbcId;
let currentIbcId;
let ibcTrayDisconnectUrl;

/**
* Binds a click event to cancel buttons to switch back to readonly view.
*
* @param {string} triggerSelector - The cancel button selector.
* @param {string} trayConsultantsList - The consultant list to hide.
* @param {string} disconnectModalContent - The disconnect to show.
*/
function handleCancelDisconnect(triggerSelector, trayConsultantsList, disconnectModalContent) {
    $('body').on('click', triggerSelector, function () {
        const $clickedElement = $(this);
        const $modalDisconnectWrapper = $('.ibc-consultant-disconnect-modal-content');

        $(trayConsultantsList).addClass('d-none');
        $(disconnectModalContent).removeClass('d-none');

        if ($clickedElement.hasClass('js-disconnect-btn')) {
            const storeId = $clickedElement.closest('.ibc-card').data('storeid');
            const $activeTray = $clickedElement.closest('.ibc-consultant-tray');
            let $trayPopup = $activeTray.find('.ibc-consultant-disconnect-modal-content');

            ibcTrayDisconnectUrl = $clickedElement.data('disconnect-url');

            // Store reference to the disconnect button for focus restoration
            // Store both the element and the storeId to find it again later
            $activeTray.data('disconnectTrigger', {
                element: $clickedElement,
                storeId: storeId
            });

            // Hide all cards
            $modalDisconnectWrapper.find('.ibc-card').addClass('d-none');

            // Show only the matching storeId card
            $modalDisconnectWrapper.find(`.ibc-card[data-storeid="${storeId}"]`).removeClass('d-none');

            tray.InitTrayModal();
            $('body').trigger('tray:adjustHeight', [$trayPopup]);

            // Move focus to the back arrow button in the disconnect modal
            // Scoped to active tray instance to avoid targeting hidden elements
            setTimeout(function() {
                const $backButton = $trayPopup.find('.js-disconnect-cancel-btn').first();
                if ($backButton.length) {
                    $backButton.focus();
                }
            }, 150);
        } else if ($clickedElement.hasClass('js-disconnect-cancel-btn')) {
            const $activeTray = $clickedElement.closest('.ibc-consultant-tray');
            let $trayPopup = $activeTray.find('.ibc-tray-consultants-list-data');

            // Restore focus to the disconnect button that opened the modal
            const disconnectTriggerData = $activeTray.data('disconnectTrigger');
            
            $('body').trigger('tray:adjustHeight', [$trayPopup]);
            
            if (disconnectTriggerData) {
                setTimeout(function() {
                    // Find the disconnect button in the now-visible consultant list
                    const storeId = disconnectTriggerData.storeId;
                    const $disconnectBtn = $activeTray.find(`.ibc-card[data-storeid="${storeId}"] .js-disconnect-btn`);
                    
                    if ($disconnectBtn.length) {
                        $disconnectBtn.focus();
                    }
                }, 150);
                $activeTray.removeData('disconnectTrigger');
            }
        }
    });
}

module.exports = {
    /**
    * disconnect ibc.
    */
    ibcDisconnect : function () {
        $('body').on('click', '.ibc-disconnect-button', function (e) {
            e.preventDefault();
            const $button = $(this);
            let disconnectUrl = $button.data('disconnect-url');
            if (ibcTrayDisconnectUrl) {
                disconnectUrl = ibcTrayDisconnectUrl;
            }
            if (!disconnectUrl) {
                return;
            }
            var url = new URL(disconnectUrl);
            var consultantNumber = url.searchParams.get('consultantNumber');
            var csrfTokenName = $('input[name*="csrf"]').attr('name') || 'csrf_token';
            var csrfTokenValue = $('input[name*="csrf"]').val() || '';
            var data = {};
            data[csrfTokenName] = csrfTokenValue;

            $.ajax({
                url: disconnectUrl,
                method: 'POST',
                data: data,
                success: function (response) {
                    if (response.success) {
                        gtm.diconnectIbc(consultantNumber);
                        if (response.redirectUrl) {
                            window.location.assign(response.redirectUrl);
                        } else {
                            window.location.reload();
                        }
                    } else {
                        if (ibcTrayDisconnectUrl) { // eslint-disable-line
                            $('body').find('.ibc-card-list .ibc-card-model-error').removeClass('d-none');
                        } else {
                            $('body').find('.ibc-disconnect .ibc-disconnect-error').removeClass('d-none');
                        }
                    }
                },
                error: function () {
                    if (ibcTrayDisconnectUrl) {
                        $('body').find('.ibc-card-list .ibc-card-model-error').removeClass('d-none');
                    } else {
                        $('body').find('.ibc-disconnect .ibc-disconnect-error').removeClass('d-none');
                    }
                }
            });
        })
    },
    setAsPrimaryData : function () {
        $('body').on('click', '.js-set-as-primary', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            const $button = $(this);
            setPrimaryUrl = $button.data('setprimary-url');
            primaryIbcId = $('.ibc-card-list').find('.ibc-card.ibc-card--primary').data('primary-ibc');
            currentIbcId = $button.closest('.ibc-card').data('storeid');
        })

        // Fallback: clear state when clicking/touching anywhere on modal/body except the highlighted buttons
        $('body').on('click', function (e) {
            var $target = $(e.target);
            if ($target.closest('.js-set-as-primary, .js-save-as-primary').length === 0 && setPrimaryUrl !== null) {
                setPrimaryUrl = null;
                primaryIbcId = null;
                currentIbcId = null;
            }
        });
    },
    saveAsPrimary : function () {
        $('body').on('click', '.js-save-as-primary', function (e) {
            e.preventDefault();
            if (!setPrimaryUrl || !primaryIbcId || !currentIbcId) {
                return;
            }

            var csrfTokenName = $('input[name*="csrf"]').attr('name') || 'csrf_token';
            var csrfTokenValue = $('input[name*="csrf"]').val() || '';
            var data = {
                primaryIbcId: primaryIbcId,
                newPrimaryIbcId: currentIbcId
            };
            data[csrfTokenName] = csrfTokenValue;

            $.ajax({
                url: setPrimaryUrl,
                method: 'POST',
                data: data,
                success: function (response) {
                    if (response.success) {
                        snackbar.show({
                            position: 'left',
                            message: response.message,
                            type: 'success'
                        });
                        setTimeout(function() {
                            window.location.reload();
                        }, 1000);
                    } else {
                        $('body').find('.ibc-card-list .ibc-card-model-error').removeClass('d-none');
                    }
                },
                error: function () {
                    $('body').find('.ibc-card-list .ibc-card-model-error').removeClass('d-none');
                }
            });
        })

        $('[data-toggle="tooltip"]').each(function () {
            var $el = $(this);

            try {
                $el.tooltip({
                    placement: 'top',
                    container: 'body',
                    html: true,
                    title: function () {
                        var contentId = $el.data('tooltip-content');
                        if (contentId && $(contentId).length) {
                            return $(contentId).html();
                        }
                        return $el.attr('title') || 'Tooltip content not available';

                    }
                });
            } catch (err) {
                console.error('Tooltip init failed for:', $el, err);
            }
        });
    },

    cancelConsultantsDisconnectModal: function () {
        handleCancelDisconnect('.js-disconnect-cancel-btn', '.ibc-consultant-disconnect-modal-content', '.ibc-tray-consultants-list-data');
    },

    consultantDisconnect: function () {
        handleCancelDisconnect('.js-disconnect-btn', '.ibc-tray-consultants-list-data', '.ibc-consultant-disconnect-modal-content');
    }
}
